import {apiGet, apiPut} from "../../shared/api/client";

const DOCUMENTS_URL = "/api/v2/admin/content/documents";

export const countryDocumentsKeys = {
    all: ["admin-content-documents"],
    list: () => ["admin-content-documents", "list"],
    document: (countryId, kind) => ["admin-content-documents", "document", String(countryId), kind],
};

// The (country, kind) address lives in the path: the request interceptor must not add
// the header country scope as a query param next to it.
const NO_HEADER_SCOPE = {skipAdminCountryScope: true};

const documentUrl = (countryId, kind) =>
    `${DOCUMENTS_URL}/${encodeURIComponent(String(countryId))}/${encodeURIComponent(kind)}`;

export const loadCountryDocuments = async () => apiGet(DOCUMENTS_URL, NO_HEADER_SCOPE);

export const loadCountryDocument = async ({countryId, kind}) => apiGet(documentUrl(countryId, kind), NO_HEADER_SCOPE);

// `revision` is the one the editor loaded: a text saved by someone else since then
// answers 409 instead of being overwritten.
export const saveCountryDocument = async ({countryId, kind, text, revision}) =>
    apiPut(documentUrl(countryId, kind), {text: text ?? "", revision: revision ?? null}, NO_HEADER_SCOPE);
